import Vue from "vue";
import _ from "underscore";
import * as mutation from "./mutation-types";
import { stateMerge } from "vue-object-merge";
import { getInitialState, getUnloadedState } from "./state";
import { getBlankRecord } from "./helpers";

export const mutations = {
  [mutation.STATE_RESET](state) {
    stateMerge(state, getInitialState());
  },
  [mutation.STATE_UNLOAD](state) {
    stateMerge(state, getUnloadedState());
  },

  [mutation.LIST_SET_FILTERS](state, { providerId }) {
    state.listing.providerId = providerId;
  },
  [mutation.LIST_SET_PAGING](state, paging) {
    stateMerge(state.listing.paging, paging);
  },
  [mutation.LIST_STARTED](state) {
    state.listing.loading = true;
  },
  [mutation.LIST_FAILED](state) {
    state.listing.loading = false;
  },
  [mutation.LIST_SUCCEEDED](state, logs) {
    state.listing.loading = false;
    state.listing.loaded = true;
    state.listing.data = logs;
    state.listing.expanded = new Array(logs.length).fill(false);
  },
  [mutation.LIST_TOGGLE_EXPAND](state, index) {
    var newValue = !state.listing.expanded[index];
    state.listing.expanded.splice(index, 1, newValue);
  },

  [mutation.FLAG_AS_PRIMARY_STARTED](state) {
    state.flagPrimary.saving = true;
  },
  [mutation.FLAG_AS_PRIMARY_FAILED](state) {
    state.flagPrimary.saving = false;
  },
  [mutation.FLAG_AS_PRIMARY_SUCCEEDED](state, contact) {
    state.flagPrimary.saving = false;
    const index = _(state.listing.data).findIndex(c => c.id == contact.id);
    Vue.set(state.listing.data, index, contact);
  },

  [mutation.GET_STARTED](state) {
    state.changeStatus.loading = true;
    state.changeStatus.data = getBlankRecord();
  },
  [mutation.GET_FAILED](state) {
    state.changeStatus.loading = false;
    state.changeStatus.loaded = false;
  },
  [mutation.GET_SUCCEEDED](state, data) {
    state.changeStatus.loading = false;
    state.changeStatus.loaded = true;
    state.changeStatus.data = data;
  },

  [mutation.SET_STATUS_STARTED](state) {
    state.changeStatus.saving = true;
  },
  [mutation.SET_STATUS_FAILED](state) {
    state.changeStatus.saving = false;
  },
  [mutation.SET_STATUS_SUCCEEDED](state, contact) {
    state.changeStatus.saving = false;
    const index = _(state.listing.data).findIndex(c => c.id == contact.id);
    Vue.set(state.listing.data, index, contact);
  }
};
